import {NextPage} from "next";
import {wrapper} from "../app/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {OrderDetailView} from "../components/orderDetail/OrderDetailView";
import {useRouter} from "next/router";
import Head from "next/head";
import React from "react";
import {useAppSelector} from "../app/hooks";
import {selectOrder} from "../redux/orderDetail/orderDetailSlice";

const OrderDetail: NextPage = () => {
  const router = useRouter()
  const orderId = router.query.order_id as string

  const order = useAppSelector(selectOrder)

  return <>
    <Head>
      <title>{`Your Order${order ? ` | ${order.vendor?.name}` : ''}`}</title>
      <meta property="og:url" key="og:url" content={`${process.env.NEXT_PUBLIC_APP_DOMAIN_URL}/order-detail?order_id=${orderId}`}/>
      <meta property="og:title" key="og:title" content={`Your Order${order ? ` | ${order.vendor?.name}` : ''}`} />
      <meta property="twitter:title" key="twitter:title" content={`Your Order${order ? ` | ${order.vendor?.name}` : ''}`}/>
    </Head>
    <OrderDetailView orderId={orderId} onClose={() => {
      router.push('/orders')
    }} />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order']),
    }
  }
});

export default OrderDetail